<div style=" display: inline;block-size: 10%;">

    <div class="col-md-12 col-12 col-sm-12 pad0 container-fluid " style="padding-right: 0px;padding: 15px 5px;">

        <div class="col-md-4 col-sm-6" style="display: inline-block; ">
            <h2 class="ng-binding header lblHeader newHeader">
                Ledger Record
            </h2>
        </div>

        <div class="col-md-8 col-sm-6" style="display: inline-block;text-align: right;">
            <span class="">
                <span class="fa fa-search" style="position: absolute!important;  padding: 9px 12px!important; font-size: 14px!important; color: #999 !important;"></span>
                <input class="form-control formCtlFltr  brdrRadius3" ng-model="search.term" placeholder="Search" matInput
                    (keyup)="applyFilter($event)" #input
                    style="text-align: left; display: inline-block; padding-left: 35px !important; font-size: 13px; box-shadow: none; width: 30% !important; height: 30px !important;"
                    type="text">
            </span>

            <div class="btn orangeButton" *ngIf="ownUserRights[0].AcctsVchrEntry"
                style="padding: 5px 14px 4px; font-size: 13px; margin-left: 10px;"
                (click)="openNewWindowVoucher('$event')" title="Enter Voucher">
                <i class="zmdi zmdi-plus headerIcon" style="margin-right: 5px;">
                </i> Enter Voucher
            </div>

            <!-- Print Settings -->
            <span (click)="openLdgrRcrdPrntPrefs('$event')" *ngIf="ownUserRights[0].AcctsVchrEntry" title="Print Settings">
                <span class="btn darkBlueButton" style="cursor: pointer;padding: 5px 11px; margin-left: 10px;">
                    <span><i class="fa fa-cog" style="font-size: 16px;"></i></span>
                </span>
            </span>

            <span (click)="printVoucher()" style="margin-right: 10px;" title="Print Statement of Accounts">
                <span class="btn darkBlueButton"
                    style="cursor: pointer;padding: 5px 11px; margin-left: 10px;">
                    <span>
                        <i aria-hidden="true" class="zmdi zmdi-print" style="font-size: 16px;"></i>
                    </span>
                </span>
            </span>

            <span (click)="refresh()" class="btn darkBlueButton"
                style="cursor: pointer;padding: 5px 11px;" title="Refresh">
                <span>
                    <i aria-hidden="true" style="font-size: 14px;" class="fa fa-refresh"></i>
                </span>
            </span>

            <span (click)="exportToExcelActivities()" *ngIf="(voucher.length > 0) && (isAdmin == true || acctReportsOnly == true)"
                class="btn darkBlueButton" style="margin-left: 10px; cursor: pointer;padding: 5px 11px;"
                title="Export to Excel">
                <span>
                    <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
                </span>
            </span>

            <div style="display: inline-block; padding: 0px;" title="Back to account">
                <span class="darkBlueButton"
                    style="font-size: 13px; display: inline-block; padding: 5px 12px 6px; margin-left: 10px;"
                    (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Back
                </span>
            </div>

        </div>



        <div class="col-md-12 col-xs-12 col-sm-12" style="padding-left: 15px; height: 40px; display: flex; justify-content: space-between; align-items: center; column-gap: 8px; margin-top: 15px;">

            <div style="display: flex; align-items: center; column-gap: 8px;">
                <div style="display: inline-block;vertical-align: bottom;padding-left: 0px;">
                    <input class="bgwhite formCtlFltr brdrRadius3" placeholder="Select Ledger" list="ledgerList" [(ngModel)]="ledgername"
                        matInput style="width: 90%;padding: 0px 8px; font-family: inherit;color: #555; font-size: 13px !important; box-sizing: border-box;" (blur)="ledgerchange(ledgername)">
                    <!-- <span class="inlnBlk " style="margin-left: 10px;"> -->
                    <datalist id="ledgerList" class="font13">
                        <option *ngFor="let option of ledgerList" [value]="option.LedgerName"> {{option.LedgerName}}
                        </option>
                    </datalist>
    
    
                        <!-- <span  *ngIf="bankList.length == 1" *ngIf="bankList.length > 0" class="inlnBlk" style="margin-left: 10px;">
                            <input type="text" list="bankLedgerList" id="txtItem" class="form-control " tabindex="1"
                                placeholder="Select a bank ledger" title="Category" (blur)="changeLedger();"
                                style=" width: 97%; background: inherit; height: 30px; cursor: pointer;"
                                [(ngModel)]="bankName">
    
                            <datalist id="bankLedgerList">
                                <option *ngFor="let a of bankList" [value]="a.BNm">{{a.BNm}}</option>
                            </datalist>
                        </span> -->
                    <!-- </span> -->
                    <!-- <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let option of ledgerList" [value]="option.LedgerName"
                    (click)="ledgerchange(option.LedgerID)">
                    {{option.LedgerName}}
                </mat-option>
            </mat-autocomplete> -->
                </div>
     
                <div style="display: flex; justify-content: center; align-items: center; columns: 8px; font-size: 14px !important; padding-left: 0px;">
                    <!-- *ngIf="selectedFY != 'Other'" -->
                    <select class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" [(ngModel)]="selectedFY" (ngModelChange)="ddlchangeYear()" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 150px !important;" [style.width]="selectedFY == 'Other' ? '90px' : '130px'">
                        <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
                        <option value="Other">Other</option>
                    </select>
    
                    <div style="display: flex; align-items: center; font-size: 13px !important; margin-left: 10px; column-gap: 10px;"
                        *ngIf="selectedFY == 'Other'">
                        <div style="outline: none !important; display: flex; align-items: center;">
                            <input #fromDateInput matInput readonly disabled="{{disable.fromInput}}" (focus)="picker.open()" [(ngModel)]="fromDate" [matDatepicker]="picker" class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 90px !important; padding: 0 8px; box-sizing: border-box;">
                            <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                        </div>
                        <div style="font-size: 15px !important; display: inline-block;">to</div>
                        <div style="outline: none !important; display: flex; align-items: center;">
                            <input #toDateInput matInput readonly disabled="{{disable.toInput}}" (focus)="picker2.open()" [matDatepicker]="picker2" class="form-control font12 formCtlFltr BzBgwhite brdrRadius3" [(ngModel)]="toDate" style="display: block; box-shadow: none; font-size: 12px; background-color: white !important; width: 90px !important; padding: 0 8px; box-sizing: border-box;">
                            <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
                        </div>
                        <div>
                            <span *ngIf="show.edit" class="orangeButton" style="width: auto; height: 30px;" [(ngModel)]="show.edit" (click)="editPeriod()">
                                <i class="zmdi zmdi-edit" style="margin-right: 5px;"></i>
                                <span> Edit </span>
                            </span>
                            <span *ngIf="show.save" class="darkBlueButton" style="width: auto; height: 30px;" [(ngModel)]="show.save" (click)="changePeriod()">
                                <i class="zmdi zmdi-arrow-right" style="margin-right: 5px;"></i>
                                <span> Fetch </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 col-sm-4 col-xs-4" style="display: inline-block; padding: 0px; text-align: right">

                <span class="label orangeBadgeCnt fntSz" style="padding: 6px 10px; margin-right: 10px;">
                    <span>
                        Opening : {{voucher[0].newCloBal |cRDB }}
                    </span>
                </span>

                <span class="label orangeBadgeCnt fntSz" style="padding: 6px 10px; ">
                    <span>
                        Closing : {{voucher[voucher.length - 1].newCloBal |cRDB }}
                    </span>
                </span>
            </div>
        </div>

        <!-- </div> -->
        <div *ngIf="ledgername.length > 0" class="col-md-12 col-xs-12 col-sm-12 pad0" style="padding-top: 20px;" #LRTable>
            <div class="col-md-12 col-12 col-sm-12  bzMatTbl shadow" style="padding: 0px; width: 80%">
                <table mat-table [dataSource]="dataSource" matSort style="width: 100%;border-radius: 3px;">
                    <ng-container matColumnDef="date">
                        <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef
                            mat-sort-header>
                            Date
                        </th>
                        <td mat-cell *matCellDef="let item ;let i=index" style="text-align: left; cursor: pointer;width: 10%;">
                            {{ item.date | todayTommorow}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="VoucherNum">
                        <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef
                            mat-sort-header>
                            <label style="cursor: pointer; margin: 0px;">Voucher No.</label>
                        </th>
                        <td mat-cell *matCellDef="let item;let i=index"
                            style="text-align: left; width: 10%; cursor: pointer;">
                            {{item.VoucherNum }}</td>
                    </ng-container>

                    <ng-container matColumnDef="MainLedger">
                        <th class="header header-Table" style="cursor: pointer; " mat-header-cell *matHeaderCellDef
                            mat-sort-header>
                            <label style="cursor: pointer; margin: 0px;">Ledger</label>
                        </th>

                        <td mat-cell *matCellDef="let item ;let i=index"
                            style="text-align: left; width: 10%; cursor: pointer;">
                            {{ item.MainLedger }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="DbAmt">
                        <th class="header header-Table" style="cursor: pointer;" arrowPosition='before' mat-header-cell *matHeaderCellDef
                            mat-sort-header>
                            <label style="cursor: pointer; margin: 0px;">Debit</label>
                        </th>
                        <td mat-cell *matCellDef="let item ;let i=index" style="padding-left: 25px; cursor: pointer; text-align: right;">

                            {{item.NewDbAmt | lacFormat }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="CrAmt">
                        <th class="header header-Table" style="cursor: pointer;" arrowPosition='before' mat-header-cell *matHeaderCellDef
                            mat-sort-header>
                            <label style="cursor: pointer; margin: 0px;">Credit</label>

                        </th>
                        <td mat-cell *matCellDef="let item ;let i=index" style="padding-left: 25px; cursor: pointer; text-align: right;">
                            {{item.NewCrAmt | lacFormat }}</td>
                    </ng-container>

                    <ng-container matColumnDef="CloBal">
                        <th class="header header-Table" arrowPosition='before' mat-header-cell *matHeaderCellDef mat-sort-header
                            style="text-align: right; cursor: pointer; margin: 0px;">
                            <label style="cursor: pointer; margin: 0px;">Balance</label>
                        </th>
                        <td mat-cell *matCellDef="let item ;let i=index" style="padding-left: 25px;cursor: pointer;width: 15%; text-align: right;">₹
                            {{ item.newCloBal | cRDB}}
                            <!-- {{newcolbal1|cRDB}} -->
                        </td>
                    </ng-container>



                    <ng-container matColumnDef="Notes" >
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                            style="text-align: right; cursor: pointer;display: none;">
                            <label style="cursor: pointer;display:none">Notes</label>
                        </th>
                        <!-- <td mat-cell *matCellDef="let item">{{item.Notes }}</td> -->
                        <td mat-cell *matCellDef="let item" style="width: 15%;">
                            <div style="padding-left: 35%">
                                <i *ngIf="item.MainLedger != 'Opening Balance' && item.MainLedger != 'Closing Balance' && (item.Notes || (item.PaymentMode && item.PaymentMode !== '0') || item.PaymentRef)"
                                    style="color:#E1A730; margin: 5px;" class="fa fa-sticky-note"
                                    title="{{item.Notes ? item.Notes : ''}}{{item.PaymentMode && item.PaymentMode !== '0' ? '-' + item.PaymentMode : ''}}{{item.PaymentRef ? '-' + item.PaymentRef : ''}}"></i>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Print">
                        <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                            style="text-align: right; cursor: pointer;">
                        </th>
                        <td mat-cell *matCellDef="let item" style="width: 10%;">
                            <div (click)="printLedger(item.VoucherID);$event.stopPropagation()"><i
                                    *ngIf="item.MainLedger != 'Opening Balance' && item.MainLedger != 'Closing Balance'"
                                    style="font-size: 17px; color: #E88421 ; cursor: pointer; "
                                    class="zmdi zmdi-print"></i>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let item; columns: displayedColumns"
                        [style.cursor]="item.MainLedger != 'Opening Balance' && item.MainLedger != 'Closing Balance'? pointer : ''"
                        (click)="ownUserRights[0].AcctsVchrEdit && item.MainLedger != 'Opening Balance' && item.MainLedger != 'Closing Balance'  ?  openEditWindowVoucher(item.VoucherID) :''">

                    </tr>
                </table>

                <!-- Angular 8 pagination -->
                <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5,10, 20]" showFirstLastButtons>
                </mat-paginator>
            </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0" style="padding: 10px;" *ngIf="ledgername.length == 0">
            <div  class="nrf brdrRadius3" style="cursor: pointer;">Please select a ledger.</div>
        </div>
    </div>
</div>

<!--Voucher Entry Modal-->
<ng-template #mymodal let-modal>
    <div class="modal-body" style="padding: 0px;">
        <app-voucher-entry (oncloseVchrModal)="closeModal($event)"></app-voucher-entry>
    </div>
</ng-template>

<!-- notes model -->

<ng-template #notemodal let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">Voucher Notes</span></h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">

        <!-- webview  -->
        <div class="col-md-12 col-sm-12 col-xs-12 mrgT10 webView" style="padding: 15px; padding-top: 0px;">
            <span class="btn1 "
                style="border-radius: 25px; background: #fff; border: 1px solid #E88421; margin-left: 0px !important; margin-right: 5px; ; color: #E88421; box-shadow: none; padding: 4px 12px;">
                <i style="padding-right: 5px; "></i><span>#
                    {{this.vouchernum}}</span>
            </span>

            <span class="btn1 "
                style="border-radius: 25px; background: #fff; border: 1px solid #DAA520; margin-left: 0px !important; margin-right: 5px;  color: #DAA520; box-shadow: none; padding: 4px 12px;">
                <i class="fa fa-calendar" style="padding-right: 5px; "></i><span>{{this.DateNote|todayTommorow}}</span>
            </span>
        </div>

        <!-- mob view -->
        <div class="col-md-12 col-sm-12 col-xs-12 mrgT10 mobView" style="padding: 15px; padding-top: 0px;">
            <span class="btn1 "
                style="border-radius: 25px; background: #fff; border: 1px solid #E88421; margin-left: 0px !important; margin-right: 5px;  color: #E88421; box-shadow: none; padding: 4px 12px;">
                <i style="padding-right: 5px;"></i><span>#
                    {{this.vouchernum}}</span>
            </span>

            <span class="btn1 "
                style="border-radius: 25px; background: #fff; border: 1px solid #DAA520; margin-left: 0px !important; margin-right: 5px;  color: #DAA520; box-shadow: none; padding: 4px 12px;">
                <i class="fa fa-calendar" style="padding-right: 5px;"></i><span>{{this.DateNote|todayTommorow }}</span>
            </span>
        </div>


        <!-- webview -->
        <div class="col-md-12 col-sm-12 col-xs-12 webView">

            <textarea class="notebrdrColor" style=" height: 60px; resize: none; border-radius: 10px!important;padding: 0px 10px 10px 10px;;width: 100%;
            border-color: #dddd!important;" readonly>{{this.vouchernote}}</textarea>
        </div>

        <!-- mob view  -->

        <div class="col-md-12 col-sm-12 col-xs-12 mobView">

            <textarea class="notebrdrColor" style=" height: 60px; resize: none; border-radius: 10px!important;padding: 0px 10px 10px 10px;;width: 100%;
            border: 1px solid #dddd!important;border-color: #dddd!important;" readonly>{{this.vouchernote}}</textarea>
        </div>

    </div>

</ng-template>

<!-- Print Settings Modal  -->
<ng-template #ldgrRcrdPrntPrefsMdl let-modal>
    <div style="border-radius: 10px;">
        <!--Header-->
        <div class="modal-header" style="border-bottom: none; padding: 15px; padding-bottom: 10px;">
            <div class="col-md-12 col-12 col-xs-12" style="padding: 0px;">
                <div style="display: flex; justify-content: space-between;">
                    <div class="col-md-8 col-10 col-xs-10" style="padding-left: 0px;">
                        <span class="modal-title" style="font-size: 18px;">Print Configuration</span>
                    </div>
                    <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                        <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closePrintSettings($event)"></i>
                    </div>
                </div>
            </div>
        </div>
        <!--Body-->
        <div class="modal-body" style="font-size: 13px; padding: 15px; padding-top: 0px;">
            <div class="row" style="padding-bottom: 10px;">
                <label class="col-md-3" style="display: flex; align-items: center; cursor: pointer;">
                    <input style="accent-color: #15305A;" type="checkbox" [(ngModel)]="ldgrRcrdPrtPrefs.isNarrrationEnbl">
                    <span style="margin-left: 10px;">Narration
                    </span>
                </label>
                
                <label class="col-md-4" style="display: flex; align-items: center; cursor: pointer;">
                    <input style="accent-color: #15305A;" type="checkbox" [(ngModel)]="ldgrRcrdPrtPrefs.isCommonNotesEnbl">
                    <span style="margin-left: 10px;">Common Notes
                    </span>
                </label>
            </div>
            <span class="btn darkBlueButton brdrRadius3" (click)="saveLdgrRcrdPrntPrefs()">
                <i class="fa fa-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>
        </div>
    </div>
</ng-template>
<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>